import React, { useEffect, useState } from 'react'
import { Box, MenuItem, Select, Typography, Button, Divider, IconButton, Dialog, DialogContent, FormControl, TextField, InputLabel, Grid } from '@mui/material'
import edit from './editicon.png';
import deleteicon from './deleteicon.png'
import { AddQuestionTemplate, ApiAddChecklistTemplate, ApiGetChecklistTemplate, ApiUpdateChecklistTemplate, DeleteQuestionTemplate, GetEntities, GetQuestionTemplate, UpdateQuestionTemplate } from '../../../../apiService/Core/Apicall.tsx';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { CancelOutlined, } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


interface FormValues {
    templateName: string;
    entityTypeId: number;
    templateDescription: string;
}
function ChecklistTemplateListing() {
    const [selectedentity, setselectedentity] = useState<number | string>(0)
    const [OpenEdit, setOpenEdit] = useState<boolean>(false)
    const [showerror, setshowerror] = useState<boolean>(false)
    const [isDelete, setisDelete] = useState<boolean>(false)
    const [filteredTemplate, setFilteredtemplate] = useState<any>('')
    const [entity, setentity] = useState<any>('')
    const [Template, setTemplate] = useState<any>('')
    const [TemplateType, setTemplateType] = useState<string>('')
    const navigate = useNavigate()

    const GetTemplate = async () => {
        const data = `?isActive=true`
        const response = await ApiGetChecklistTemplate(data)
        console.log(response.data)
        setTemplate(response.data)
    }
    useEffect(() => {
        const fetchentities = async () => {
            const entities = await GetEntities()
            setentity(entities.data)
        }

        GetTemplate()
        fetchentities()
    }, [OpenEdit, showerror])


    const initialValues: FormValues = ({
        templateName: '',
        entityTypeId: 0,
        templateDescription: ""
    })
    const validationSchema = Yup.object({
        templateName: Yup.string()
            .required("Template Name is required"),
        entityTypeId: Yup.number()
            .required("Entity is required")
            .positive("Entity must be a positive number")
            .integer("Entity must be an integer"),
    });

    const onSubmit = async (Values: FormValues, { resetForm }: { resetForm: () => void }) => {
        callTemplateAPis(Values)
        resetForm()
    }

    const callTemplateAPis = async (Values: any) => {
        try {
            const response = await (TemplateType === 'Create' ? ApiAddChecklistTemplate(Values) : ApiUpdateChecklistTemplate(Values))
            toast.success(response.message)
            setshowerror(true)
            setOpenEdit(false)
            console.log("Send Values", Values)
        }
        catch (error: any) {
            toast.error(error?.message)
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    })

    const updateTemplate = (item: any) => {
        formik.setValues({
            ...formik.values,
            templateName: item.templateName,
            entityTypeId: item.entityTypeId.entityTypeId,
            templateDescription: item.templateDescription,
            ...(item.checklistTemplateId ? { checklistTemplateId: item.checklistTemplateId } : {}),
        })
        setOpenEdit(true);
        setTemplateType('update')
    }
    const deleteTemplate = async (item: any) => {
        console.log(item)
        const isDelete = window.confirm('Are You Sure ?')
        if (isDelete) {
            const data ={
                checklistTemplateId: item?.checklistTemplateId,
                isActive: false
            }
            const response = await ApiUpdateChecklistTemplate(data)
            if (response?.status) {
                toast.success(response.message)
                GetTemplate()
            }
        }
    }

    useEffect(() => {
        let filtered = Template;

        if (selectedentity) {
            filtered = filtered.filter((q: any) => q.entityTypeId.entityTypeId === selectedentity);
        }

        setFilteredtemplate(filtered);
    }, [selectedentity, Template]);
    return (
        <Box className='w-100 p-2 extra'>
            <Box className='bg-white p-2 py-3 border-10'>
                <Grid container className='p-2 px-3' gap={2} >
                    <Grid size={{ xs: 12, md: "grow" }}>
                        <Typography variant='h5' textAlign={{ xs: "center", md: "start" }}>Checklist Template Listing</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }}>
                        {/* <Box className='d-flex col-4 p-0 justify-content-end align-items-stretch' gap={2}> */}
                        <Grid container gap={2}>
                            <Grid size={{ xs: 12, md: 'auto' }}>
                                <Select
                                    className='col-12'
                                    id="demo-simple-select"
                                    value={selectedentity}
                                    onChange={(e) => setselectedentity(e.target.value)}
                                >
                                    <MenuItem value={0}>All</MenuItem>

                                    {entity.length > 0 &&
                                        entity.map((cat: any) => (
                                            <MenuItem value={cat.entityTypeId} key={cat.entityTypeId}>
                                                {cat.entityTypeName}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </Grid>
                            <Grid size={{ xs: 12, md: 'auto' }}>
                                <Button className='bg-grey text-light px-4 py-1 transform m-0' onClick={() => { setOpenEdit(true); setTemplateType('Create') }}>Add Template</Button>
                            </Grid>
                        </Grid>
                        {/* </Box> */}
                    </Grid>
                </Grid>
                <Divider className='my-2' />
                <Box className='p-0 p-2 p-md-3'>
                    <Box className='d-flex align-items-center flex-wrap' justifyContent={'start'} gap={2}>
                        {filteredTemplate.length > 0 && filteredTemplate.map((item: any, index: number) => (
                            <Box width={{ xs: "100%", md: "49%" }} flexDirection={{ xs: "column", md: "row" }} alignItems={{ xs: "start", md: "center" }} key={index} className='p-2 d-flex  text-dark justify-content-between' sx={{ borderRadius: "10px", border: '1px solid black' }}>
                                <Link to={`/admin/checklist/template-question/${item?.templateName}/${item?.checklistTemplateId}`}
                                style={{flex:1, color:'#000000'}}>
                                    <Typography variant='subtitle1' className='fw-bold'>{item.templateName}</Typography>
                                </Link>
                                <Box className='d-flex align-items-center'>
                                    <Typography borderRadius='5px' className='px-3 py-1 align-items-center d-flex text-center bg-light-primary'>{item?.entityTypeId && item?.entityTypeId?.entityTypeName || 'undefined'}</Typography>
                                    <IconButton className='mr-0' onClick={() => { updateTemplate(item) }}>
                                        <Box component='img' height='32px' src={edit}></Box>
                                    </IconButton>
                                    <IconButton className='pl-0 ml-0' onClick={() => { deleteTemplate(item) }}>
                                        <Box component='img' height='32px' src={deleteicon}></Box>
                                    </IconButton>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Dialog open={OpenEdit} className='extra' fullWidth>
                <DialogContent >
                    <Box className='d-flex justify-content-end'>
                        <IconButton onClick={() => { setOpenEdit(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <Typography variant='h5' className='text-center my-2 fw-bold'>{TemplateType} Template</Typography>
                    <form onSubmit={formik.handleSubmit}>
                        <Box className='d-flex flex-column pt-4' height='40vh' gap={5}>
                            <FormControl>
                                <InputLabel>Template Name</InputLabel>
                                <TextField value={formik.values.templateName} onBlur={formik.handleBlur} onChange={(e) => { formik.setFieldValue('templateName', e.target.value) }} />
                                {formik.touched.templateName && formik.errors.templateName && <Typography className='text-danger' variant='caption'>{formik.errors.templateName}</Typography>}
                            </FormControl>
                            <FormControl>
                                <InputLabel id="entity" shrink={false}>Business Type</InputLabel>
                                <Select
                                    labelId='entity'
                                    id="demo-simple-select"
                                    value={formik.values.entityTypeId}
                                    onChange={(e) => formik.setFieldValue("entityTypeId", e.target.value)}
                                >
                                    <MenuItem value={0} disabled>Select Type</MenuItem>

                                    {entity.length > 0 &&
                                        entity.map((cat: any) => (
                                            <MenuItem value={cat.entityTypeId} key={cat.entityTypeId}>
                                                {cat.entityTypeName}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                                {showerror && formik.errors.entityTypeId && <Typography className='text-danger' variant='caption'>{formik.errors.entityTypeId}</Typography>}

                            </FormControl>
                            <FormControl>
                                <InputLabel>Template Description</InputLabel>
                                <TextField sx={{ ".MuiOutlinedInput-root": { padding: 0 } }} multiline rows={2} value={formik.values.templateDescription} onChange={(e) => { formik.setFieldValue('templateDescription', e.target.value) }} />
                            </FormControl>
                            <Button type='submit' className='px-3 bg-grey transform text-light mt-auto' onClick={() => { setshowerror(true) }}>Save</Button>
                        </Box>
                    </form>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default ChecklistTemplateListing
